export default "__VITE_ASSET__GNzxSyd6__"